<template>
    <v-btn v-if="endShow" tile block depressed @click="$router.back()">Назад</v-btn>
</template>

<script>
export default {
    props: {
        show: Boolean
    },
    computed: {
        globalShow() {
            return this.$sg.options.showBack
        },


        endShow() {
            return this.globalShow || this.show
        }
    }
}
</script>

<style>

</style>